(function () {
  'use strict';

  function initCarousel(section) {
    const slides = Array.from(section.querySelectorAll('.rc-slide'));
    const dots   = Array.from(section.querySelectorAll('.rc-dot'));
    const prev   = section.querySelector('.rc-arrow--prev');
    const next   = section.querySelector('.rc-arrow--next');
    const speed  = parseInt(section.dataset.autoplaySpeed || '5', 10) * 1000;

    if (!slides.length) return;

    let current  = 0;
    let timer    = null;
    let isAnimating = false;

    function goTo(index, dir) {
      if (isAnimating || index === current) return;
      isAnimating = true;

      const outgoing = slides[current];
      const incoming = slides[index];

      outgoing.classList.add('is-exiting');
      outgoing.classList.remove('is-active');
      outgoing.setAttribute('aria-hidden', 'true');

      incoming.style.transform = dir === 'next' ? 'translateX(40px)' : 'translateX(-40px)';
      incoming.style.opacity = '0';
      incoming.style.visibility = 'visible';

      incoming.getBoundingClientRect();

      incoming.classList.add('is-active');
      incoming.setAttribute('aria-hidden', 'false');
      incoming.style.transform = '';
      incoming.style.opacity = '';

      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      if (dots[index]) {
        dots[index].classList.add('is-active');
        dots[index].setAttribute('aria-selected', 'true');
      }

      current = index;

      setTimeout(function () {
        outgoing.classList.remove('is-exiting');
        outgoing.style.visibility = '';
        isAnimating = false;
      }, 520);
    }

    function goNext() {
      const next = (current + 1) % slides.length;
      goTo(next, 'next');
    }

    function goPrev() {
      const prev = (current - 1 + slides.length) % slides.length;
      goTo(prev, 'prev');
    }

    function startAutoplay() {
      stopAutoplay();
      timer = setInterval(goNext, speed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (next) {
      next.addEventListener('click', function () {
        stopAutoplay();
        goNext();
        startAutoplay();
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        stopAutoplay();
        goPrev();
        startAutoplay();
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        const dir = i > current ? 'next' : 'prev';
        goTo(i, dir);
        startAutoplay();
      });
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', startAutoplay);

    let touchStartX = 0;
    section.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    section.addEventListener('touchend', function (e) {
      const diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        stopAutoplay();
        if (diff > 0) { goNext(); } else { goPrev(); }
        startAutoplay();
      }
    }, { passive: true });

    startAutoplay();
  }

  function init() {
    document.querySelectorAll('.reviews-carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector('.reviews-carousel');
    if (section) initCarousel(section);
  });

})();
